export const streamOgImages = {
  // https://synoptic.com/p/streams/01JEYDKB3PH1WJ1BANH2V0H9HP
  '01JEYDKB3PH1WJ1BANH2V0H9HP': 'https://synoptic.com/static/trump-cover.jpg',
};
